import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Iservices } from '../interfaces/servicesResponse';
import {MatIconModule} from '@angular/material/icon';


@Component({
  selector: 'app-mat-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule, MatIconModule],
  templateUrl: './mat-dialog.component.html',
  styleUrl: './mat-dialog.component.scss'
})
export class MatDialogComponent {

  dialogType?: string;
  appointmentId?: string;
  appointmentNo?: string;
  serviceDetails: Iservices;
  noText: string = $localize `No`;
  yesText: string = $localize `Yes`;

  constructor(private dialogRef: MatDialogRef<MatDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = false;
    this.dialogType = data.dialogType;
    this.appointmentId = data.appointmentId;
    this.appointmentNo = data.appointmentNo;
    this.serviceDetails = data.serviceDetails;
  }


}
